import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Stack,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import i18next from 'i18next';
import { Base64 } from 'js-base64';
import Cookies from 'js-cookie';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiSolidError } from 'react-icons/bi';
import { MdOutlineScreenShare } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { enterPlayGame } from '../../api/postApi';
import { COMMON_WEB_PATH, DATA2_PATH } from '../../constant';
import useCurrentCurrencyIsCrypto from '../../hook/useCurrentCurrencyIsCrypto';
import useDeviceType from '../../hook/useDeviceType';
import useGetNowGame from '../../hook/useGetNowGame';
import useIsLandScape from '../../hook/useIsLandScape';
import useTransferMode from '../../hook/useTransferMode';
import { languageMapping } from '../../i18n/config';
import {
  closeVipBar,
  endGameLoading,
  openFullScreen,
  startGameLoading,
  storeGameConfig,
  storeGameLink
} from '../../redux/action/game/gameAction';
import {
  openChat,
  openGameDescriptionPop
} from '../../redux/action/member/memberAction';
import { isEmptyObject } from '../../utils/isEmptyObject';
import FreezeWrapper from '../StatusModal/FreezeWrapper';
import BetLimitInfo from './components/BetLimitInfo';
import GameBoxMore from './components/gameBoxMore';
import GameMarquee from './components/GameMarquee/GameMarquee';
import HiddenAddressBar from './components/HiddenAddressBar';
import NoticeTransfer from './components/noticeTransfer';
import SupportCurrency from './components/supportCurrency';
import ToolTab from './components/toolTab';
import TransferButton from './components/TransferInGame/transferButton';
import useGameIsHasDescription from './gameDescription/gameIsHasDescription';

const GameBox = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);

  const dispatch = useDispatch();
  const gameLink = useSelector((state) => state.isGameLink);
  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);
  const gameConfig = useSelector((state) => state.isGameConfig);
  const gameTrigger = useSelector((state) => state.isTriggerGameLink);
  const gameLoading = useSelector((state) => state.isGameLoading);
  const isAccessToolOpen = useSelector((state) => state.isAccessTool);
  const walletCurrency = useSelector((state) => state.isWalletCurrency);

  const isMobile = useDeviceType() === 'Mobile';

  const [showBar, setShowBar] = useState(true);
  const [toolbarHint, setToolbarHint] = useState(true);
  const [showGameBoxMore, setShowGameBoxMore] = useState(false);
  const [showAlertPop, setShowAlertPop] = useState(false);
  const [testing, setTesting] = useState(false);
  const [triggerTransferPop, setTriggerTransferPop] = useState(false);
  const [isNotSupportIframe, setIsNotSupportIframe] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const [isTransferModePop, setIsTransferModePop] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const [cryptoModal, setCryptoModal] = useState(false);
  const [cryptoButtonTrigger, setCryptoButtonTrigger] = useState(false);
  const [isHtmlCode, setIsHtmlCode] = useState(false);
  const [betLimitInfo, setBetLimitInfo] = useState(null);

  const isTransferMode = useTransferMode();

  const walletCurrencyNow = useSelector((state) => state.isWalletCurrency); //從redux裡取isWalletCurrency的值 存到WalletCurrencyNow
  const gameCurrencyNow = useSelector((state) => state.isGameCurrency); //從redux裡取isWalletCurrency的值 存到gameCurrencyNow
  const memberData = useSelector((state) => state.isMemberInfo);
  const { status } = memberData || {};

  const currentCurrencyIsCrypto = useCurrentCurrencyIsCrypto();

  const isMobileAndLandScape = useIsLandScape({ isMobile: true });
  const isLandScape = useIsLandScape();

  const confirmBg = useColorModeValue('dark.200');

  /***********************
   * 禁止橡皮筋及外層滾動
   ***********************/

  //鎖定外層滾動、允許特定區域滾動 針對特定區域選擇性地允許滾動
  //目的是阻止頁面的橡皮筋效應，但允許標記為 "scrollable" 的元素滾動。
  //這樣可以讓 HiddenAddressBar 組件可滾動，而其他區域不可滾動。

  useEffect(() => {
    //阻止非滾動區域的觸摸移動事件，避免產生橡皮筋效應 * @param {TouchEvent} e - 觸摸移動事件對象
    const preventTouchMove = (e) => {
      // 如果觸發的元素不在任何 .scrollable 的區域中 就阻止預設觸控行為（即阻止滾動）
      if (!e.target.closest('.scrollable')) {
        e.preventDefault();
      }
    };

    // 只有以下條件時才應用滾動限制：
    if (isOpenFullScreen && isMobileAndLandScape) {
      // 如果是全螢幕模式且是手機橫式 針對 body 加上監聽器 防止 touchmove 預設行為(禁止橡皮筋效果)
      // 向 body 添加事件監聽器
      // passive: false 告訴瀏覽器我們會調用 preventDefault()
      // 這樣可以確保在高性能滾動實現（如 iOS 的慣性滾動）中也能正確工作
      document.body.addEventListener('touchmove', preventTouchMove, {
        passive: false
      });
    }
    return () => {
      // 清理函數 - 在組件卸載或依賴項變化時移除事件監聽器
      document.body.removeEventListener('touchmove', preventTouchMove);
    };
  }, [isOpenFullScreen, isMobileAndLandScape]);

  // 額外針對 document 加上全域 touchmove 監聽 (如果不需要特別區分滾動區，可直接用這個)
  // 這是一個更嚴格的版本，完全禁止所有觸摸移動事件 如果第一個 useEffect 不足以解決問題，可以用這個
  useEffect(() => {
    const preventTouchMove = (e) => {
      // 無條件阻止所有觸摸移動事件的默認行為
      e.preventDefault();
    };

    if (isOpenFullScreen && isMobileAndLandScape) {
      // 但這次是向 document 添加事件監聽器，而不是 body
      // 這可以確保捕獲所有觸摸移動事件，不僅僅是 body 上的
      document.addEventListener('touchmove', preventTouchMove, {
        passive: false
      });
    }
    return () => {
      document.removeEventListener('touchmove', preventTouchMove);
    };
  }, [isOpenFullScreen, isMobileAndLandScape]);

  useEffect(() => {
    if (isTransferMode) {
      setIsTransferModePop(true);
    } else {
      setIsTransferModePop(false);
    }
  }, [isTransferMode]);

  const nowGameConfig = useGetNowGame();

  useEffect(() => {
    if (isEmptyObject(gameConfig)) {
      dispatch(storeGameConfig(nowGameConfig));
    }
  }, [nowGameConfig]);

  useEffect(() => {
    setIsHtmlCode(false);

    if (currentCurrencyIsCrypto) {
      setCryptoModal(true);
    }
  }, [gameConfig?.gameUid, currentCurrencyIsCrypto]);

  useEffect(() => {
    if (firstRender) {
      dispatch(closeVipBar());
      setFirstRender(false);
      return;
    }
    if (cryptoModal) {
      return;
    }
    dispatch(startGameLoading());
    setShowAlertPop(false);
    if (!isEmptyObject(gameConfig) && walletCurrencyNow) {
      enterPlayGame({
        gameUid: gameConfig.gameUid,
        gameCode: gameConfig.gameCode,
        isMobile: !isLandScape || isMobile ? 2 : 1,
        lang: languageMapping(i18next.language),
        gameCurrencyNow: currentCurrencyIsCrypto
          ? gameCurrencyNow
          : walletCurrencyNow,
        walletCurrencyNow: walletCurrencyNow
      })
        .then((data) => {
          const game_link = Base64.decode(data.url);
          dispatch(storeGameLink(game_link));

          setIsNotSupportIframe(data.not_supported_iframe);
          if (data.not_supported_iframe) {
            const newWindow = window.open('', '_blank');
            if (newWindow) {
              newWindow.location.href = game_link;
            }
          }
          dispatch({ type: 'GET_BALANCE' });

          if (!data.not_supported_iframe) {
            if (
              gameConfig?.game_type === 'LIVE' ||
              gameConfig?.game_type === 'SPORT' ||
              gameConfig?.game_type === 'LOTTERY'
            ) {
              dispatch(openFullScreen());
            }
          }
          setShowAlertPop(false);
          setIsPortrait(data.portrait); //這裡從後端拿到的portrait判斷是直式還是橫式

          if (data.is_html_code) {
            setIsHtmlCode(true);
          } else {
            setIsHtmlCode(false);
          }
          if (data?.bet_limit_info) {
            setBetLimitInfo(data.bet_limit_info);
          }
        })
        .catch((err) => {
          if (err.name === 'CanceledError') {
            return;
          }
          if (
            err.response.data.message == '遊戲不支援此幣別' &&
            currentCurrencyIsCrypto
          ) {
            setCryptoModal(true);
          }
          setShowAlertPop(true);
        })
        .finally(() => {
          dispatch(endGameLoading());
        });
    }
  }, [
    gameConfig,
    i18next.language,
    gameTrigger,
    walletCurrencyNow,
    gameCurrencyNow,
    firstRender,
    cryptoModal,
    cryptoButtonTrigger,
    isLandScape
  ]); //把currentCurrency加進去，如果幣別改變，遊戲頁面會重新刷新

  const { to } = useParams();

  const gameIsHasDescription = useGameIsHasDescription({ game_platform: to });

  const gameBoxComponents = useMemo(() => {
    if (cryptoModal) {
      return (
        <Box
          w="300px"
          py="20px"
          borderRadius={`common`}
          bg={'dark.200'}
          px="20px"
        >
          <Stack spacing={`3`}>
            {currentCurrencyIsCrypto && (
              <SupportCurrency
                selectProps={{
                  bg: 'dark.300',
                  border: ''
                }}
              />
            )}
            <Divider />
            <Button
              variant={`brandPrimary`}
              size="md"
              type="button"
              onClick={() => {
                setCryptoButtonTrigger(!cryptoButtonTrigger);
                setCryptoModal(false);
              }}
            >
              {i18n('openGame')}
            </Button>
          </Stack>
        </Box>
      );
    }
    if (gameLoading) {
      return (
        <Stack w="100%" h="100%" spacing={`3`}>
          <Image
            w="100%"
            h="100%"
            src={`${COMMON_WEB_PATH}/blue-layout/loading_bg.png `}
            objectFit={{
              base: 'cover'
            }}
          />

          <Box w="100%">
            <Image
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              w={{
                base: '100%',
                md: '330px'
              }}
              h="auto"
              src={`${COMMON_WEB_PATH}/blue-layout/animated_logo.png`}
              alt="Logo"
            />
          </Box>
        </Stack>
      );
    }
    if (isNotSupportIframe) {
      return (
        <Flex
          direction={`column`}
          alignItems={`center`}
          gap="20px"
          color="light.200"
        >
          <MdOutlineScreenShare className="text-[100px] text-yellow-500" />
          <Text as="span" fontSize="2xl">
            {i18n('gameNotSupportIframe')}
          </Text>
          <Button
            variant={`brandPrimary`}
            size="md"
            type="button"
            onClick={() => {
              window.open(gameLink, '_blank');
            }}
          >
            {i18n('openGame')}
          </Button>
        </Flex>
      );
    }
    if (showAlertPop) {
      if (status == 2 || status == 4 || status == 5) {
        return null;
      } else {
        return (
          <Flex
            direction={`column`}
            alignItems={`center`}
            gap="20px"
            color="light.200"
          >
            <BiSolidError className="text-[100px] text-red-500" />
            <Text textAlign={`center`} as="span" fontSize="2xl">
              {i18n('The game link is abnormal')}
            </Text>
            <Button
              variant={`brandPrimary`}
              size="md"
              type="button"
              onClick={() => {
                dispatch(openChat());
              }}
            >
              {i18n('contactCustomerServiceNow')}
            </Button>
          </Flex>
        );
      }
    }
    return (
      <>
        {testing && (
          <Box
            as="section"
            position="absolute"
            w="100%"
            h="100%"
            top="0px"
            left="0px"
            display="flex"
            alignItems={`center`}
            justifyContent={`center`}
            bg="black"
          >
            <Text as="span" fontSize="4xl" color="light.200">
              {i18n('gameIsTestingPleaseDontPlay')}
            </Text>
          </Box>
        )}

        <iframe
          src={gameLoading ? '' : isHtmlCode ? undefined : gameLink}
          srcdoc={gameLoading ? '' : isHtmlCode ? gameLink : undefined}
          className={`flex-1 ${!isOpenFullScreen && 'mx-auto w-[330px]'} ${
            isPortrait ? '!w-[70%]' : '' // 條件渲染，如果是直式，設定寬度為 70%
          } w-full bg-[#272727] md:rounded-b-xl`}
        ></iframe>
      </>
    );
  }, [
    gameLoading,
    isTransferModePop,
    isMobile,
    isNotSupportIframe,
    showAlertPop,
    cryptoModal,
    currentCurrencyIsCrypto,
    isOpenFullScreen,
    isHtmlCode,
    status
  ]);

  useEffect(() => {
    if (gameIsHasDescription && !isMobile && Cookies.get(`notice_${to}`) != 1) {
      dispatch(openGameDescriptionPop({ game: to }));
    }
  }, [gameIsHasDescription, isMobile]);

  useEffect(() => {
    setTimeout(() => {
      setToolbarHint(false);
    }, 3000);
  }, []);

  return (
    <>
      <Flex
        position={{
          base: 'fixed',
          md: isMobileAndLandScape ? 'fixed' : 'unset'
        }}
        top="0px"
        left="0px"
        bottom="0px"
        direction={'column'}
        w="100%"
        h="100%"
        flex={1}
      >
        <Box
          flexDirection={`column`}
          overflowX="hidden"
          // w="100%"
          flex={1}
          display={{
            base: 'flex'
          }}
          // position={{
          //   base: "relative",
          //   lg: "static",
          // }}
          // zIndex={`1001`}
          // className={`webkit-height`}
        >
          <meta name="apple-mobile-web-app-capable" content="yes" />

          {triggerTransferPop &&
          isTransferMode &&
          !isEmptyObject(gameConfig) ? (
            <NoticeTransfer
              triggerTransferPop={triggerTransferPop}
              setTriggerTransferPop={setTriggerTransferPop}
            />
          ) : null}
          <Box
            h="100%"
            borderBottomRadius={{
              md: 'xl'
            }}
            display={`flex`}
            flexDirection={`column`}
            alignItems={`center`}
            justifyContent={`center`}
            color={`white`}
            w="100%"
            bg="gamebox.base"
            position="relative"
            // overflow={"hidden"}
          >
            {/* <AbsoluteCenter
            position={"absolute"}
            w="102%"
            h="110%"
            bgImage={`${COMMON_WEB_PATH}/FlyDragon/free_background_landscape.png`}
            opacity={0.2}
            bgRepeat={`no-repeat`}
            bgSize={`100% 100%`}
          ></AbsoluteCenter> */}
            <GameMarquee />
            <BetLimitInfo betLimitInfo={betLimitInfo} />
            <FreezeWrapper>{gameBoxComponents}</FreezeWrapper>
          </Box>
          <ToolTab />
          <TransferButton />

          {isAccessToolOpen && (
            <GameBoxMore setShowGameBoxMore={setShowGameBoxMore} />
          )}
        </Box>
      </Flex>
      <HiddenAddressBar />
    </>
  );
};

export default GameBox;
